var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.514357 4.15877C0.196892 4.33514 0 4.66977 0 5.03293V9.67161C0 13.3033 1.96892 16.6495 5.14357 18.4132L7.51436 19.7303C7.81638 19.8981 8.18362 19.8981 8.48564 19.7303L10.8564 18.4132C14.0311 16.6495 16 13.3033 16 9.67161V5.03293C16 4.66976 15.8031 4.33514 15.4856 4.15877L8.48564 0.269886C8.18362 0.102095 7.81638 0.102095 7.51436 0.269886L0.514357 4.15877ZM6.96967 12.5304C7.26256 12.8233 7.73743 12.8233 8.03033 12.5304L12.0303 8.53041C12.3232 8.23752 12.3232 7.76265 12.0303 7.46975C11.7374 7.17686 11.2626 7.17686 10.9697 7.46975L7.5 10.9394L6.03033 9.46975C5.73744 9.17686 5.26256 9.17686 4.96967 9.46975C4.67678 9.76265 4.67678 10.2375 4.96967 10.5304L6.96967 12.5304Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldBlack);
export default __webpack_public_path__ + "static/media/ShieldBlack.732a9a44696dba5550656cbb74c513f1.svg";
export { ForwardRef as ReactComponent };